import React from "react";
import { FaBuilding } from "react-icons/fa";

// Must match the KYC documents (PAN / bank account) submitted to the payment gateway.
// Kept static on purpose: not editable from the admin app, so it can't drift from KYC.
export const LEGAL_ENTITY = {
  legalName: "Tejas Ganesh Patil",
  constitution: "Sole Proprietorship",
  tradeName: "Ganesh Holiday Homes",
  registeredAddress:
    "Narayan Pakhadi Rd, Narayan Pakhadi, Shrivardhan, Raigad - 402110, Maharashtra, India",
  email: "ganeshholidayhomes@gmail.com",
  phone: "+91 9673150591",
};

const LegalEntityDetails = () => (
  <div
    className="mx-auto mt-4 p-4 rounded-4 bg-white border"
    style={{ maxWidth: "900px" }}
  >
    <div className="d-flex align-items-center gap-2 mb-3 text-danger">
      <FaBuilding className="fs-5" />
      <h2 className="h6 fw-bold mb-0 text-dark font-heading text-uppercase">Legal Entity Details</h2>
    </div>
    <p className="small text-secondary mb-3">
      This website and all bookings and payments made on it are operated by the business below.
    </p>
    <dl className="row small mb-0">
      <dt className="col-sm-4 text-dark">Legal Name</dt>
      <dd className="col-sm-8 text-secondary">{LEGAL_ENTITY.legalName}</dd>

      <dt className="col-sm-4 text-dark">Trade Name</dt>
      <dd className="col-sm-8 text-secondary">{LEGAL_ENTITY.tradeName}</dd>

      <dt className="col-sm-4 text-dark">Constitution</dt>
      <dd className="col-sm-8 text-secondary">{LEGAL_ENTITY.constitution}</dd>

      <dt className="col-sm-4 text-dark">Registered Address</dt>
      <dd className="col-sm-8 text-secondary">{LEGAL_ENTITY.registeredAddress}</dd>

      <dt className="col-sm-4 text-dark">Email</dt>
      <dd className="col-sm-8 text-secondary">
        <a href={`mailto:${LEGAL_ENTITY.email}`} className="text-decoration-none">{LEGAL_ENTITY.email}</a>
      </dd>

      <dt className="col-sm-4 text-dark">Phone</dt>
      <dd className="col-sm-8 text-secondary mb-0">{LEGAL_ENTITY.phone}</dd>
    </dl>
  </div>
);

export default LegalEntityDetails;
